export default "__VITE_ASSET__CRe0XpR4__"